import RestClient from '@/api/api';

class ConversationAPI extends RestClient {
  async getConversation(reportId) {
    return this._get(`/reports/${reportId}/conversation`);
  }

  async sendMessage(reportId, content) {
    return this._post(`/reports/${reportId}/conversation/messages`, {
      message: { content }
    });
  }
}

export default new ConversationAPI();
